var _path, _ellipse;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileIncognito(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5002 25.2408C30.4702 25.2408 36.1205 19.5904 36.1205 12.6204C36.1205 5.65044 30.4702 0 23.5002 0C16.5301 0 10.8798 5.65037 10.8798 12.6203C10.8798 19.5903 16.5301 25.2408 23.5002 25.2408ZM29.481 17.6155C28.9069 19.5138 26.4477 20.9407 23.5002 20.9407C20.5527 20.9407 18.0934 19.5137 17.5193 17.6155H29.481ZM44.8243 38.2963V42.4564C44.8243 43.073 44.3702 43.7895 43.807 44.0402C41.6238 45.0116 35.6687 47 23.5002 47C11.3315 47 5.3766 45.0116 3.19341 44.0402C2.6301 43.7895 2.17615 43.073 2.17615 42.4564V38.2963C2.17615 32.0624 6.92253 26.8908 12.9789 26.1982C13.1629 26.1771 13.4358 26.2559 13.5859 26.3645C16.3783 28.3861 19.797 29.5926 23.5002 29.5926C27.2033 29.5926 30.6222 28.3861 33.4145 26.3645C33.5646 26.2559 33.8375 26.1771 34.0215 26.1982C40.0778 26.8908 44.8243 32.0624 44.8243 38.2963Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.4999,
    cy: 12.3095,
    rx: 12.3095,
    ry: 12.3095,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIncognito);
export default __webpack_public_path__ + "static/media/profile-incognito.e31a69ab9857c8e61af6eeff294ce1c0.svg";
export { ForwardRef as ReactComponent };